import React from 'react'
import Popup from '../../../components/popup/Popup'
import Button from '../../../components/button/Button'
import styles from "./EFileSubscriptionReminderPopup.styles"
import { BUTTON_TYPE } from '../../../components/button/constants'
import General from '../../../../libs/utility/General'

function EFileSubscriptionReminderPopup({ isOpen, onCloseCb, currentPlanUpgradeClickCb, subscribeForYearClickCb, htmlContent }) {

    return (
        <Popup title={"Your eFile Plus Subscription Reminder"} onCloseCb={onCloseCb} isPopupOpen={isOpen} childrenStyles={styles.childrenStyles} customPopupSyles={styles.customPopupStyles}>
            <div dangerouslySetInnerHTML={{ __html: General.sanitizeContent(htmlContent ?? '') }} style={styles.popupBodyWrapper} />
            <div style={styles.buttonsContainer}>
                <Button type={BUTTON_TYPE.DANGER} onClickCb={currentPlanUpgradeClickCb}>Current plan Upgrade</Button>
                <Button onClickCb={subscribeForYearClickCb}>Subscribe for Year</Button>
            </div>
        </Popup>
    )
}

export default EFileSubscriptionReminderPopup